export const faqs = [
  {
    q: "「在线黑料」为什么需要专门做真假鉴定？",
    a: "网络流传的黑料往往自带情绪与转发冲动，而单张截图、掐头去尾的视频和匿名信源很难还原全貌。专门的真假鉴定能在情绪发酵前补充时间线、出处与多方说法，避免读者被断章取义的片段带偏判断。",
  },
  {
    q: "你们的核查结论一定是对的吗？",
    a: "我们不承诺「绝对正确」。所有结论都基于当时可获得的公开信源与证据，并标注可信度评分与存疑程度。一旦出现新证据，我们会重新复核并更新旧结论，而非固化某个说法。",
  },
  {
    q: "判断一条黑料是真是假，一般看哪几点？",
    a: "一看信源权威度，是否来自官方或原发机构；二看证据完整度，是否提供时间地点与上下文；三看动机，传播者是否有利益或情绪倾向；四看速度，越爆越快的内容越需要冷静等待核实。",
  },
  {
    q: "截图和视频为什么不能直接当作实锤？",
    a: "截图可以被伪造或断章取义，视频也可能被重新配音、变速或拼接。可靠的证据应当能还原完整上下文，并与公开记录、第三方说法相互印证，单一素材很难构成充分实锤。",
  },
  {
    q: "我发现一条疑似不实黑料，如何提交线索？",
    a: "你可以在页面底部的「提交线索」表单中粘贴原始链接与截图，并尽量说明你的疑虑点。核查团队会先做信源分级与初筛，符合条件的话题会进入正式核查流程并在站内更新。",
  },
  {
    q: "辟谣专区里的内容会一直保留吗？",
    a: "会。已证伪的黑料与辟谣要点会持续留档，并标注辟谣时间与依据，方便读者检索和复核，避免同一谣言换个标题再度传播时无人对证。",
  },
];